/**
 * Delays execution for a specified number of milliseconds.
 * @param ms Number of milliseconds to delay.
 */
export const delay = async (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/**
 * Runs a promise with a timeout. Rejects if the promise does not resolve within the given time.
 * @param promise The promise to run.
 * @param ms Timeout in milliseconds.
 * @param timeoutMessage Optional custom timeout error message.
 */
export const withTimeout = async <T>(
  promise: Promise<T>,
  ms: number,
  timeoutMessage = 'Operation timed out',
): Promise<T> => {
  let timeoutId: any
  const timeoutPromise = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error(timeoutMessage)), ms)
  })

  try {
    return await Promise.race([promise, timeoutPromise])
  } finally {
    clearTimeout(timeoutId)
  }
}
